import { httpRequest } from "../../http";

export class CommandReorderFolder {
  async run(parentFolderId: number, orderedIds: number[]) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/folders/${parentFolderId}/reorder/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
        body: { ordered_ids: orderedIds },
      });
      return response;
    } catch (error) {
      console.error("Error reordering folder:", error);
      throw error;
    }
  }
}
